export const GALLERY_TRACKING_ZONE = 'pp_content_carousel'
export const GALLERY_IMPRESSION_TRACKING_ZONE = 'pp_carousel'
